import { Link } from "react-router-dom";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuickEntry from "@/pages/home/components/CategoryQuickEntry";
import LatestNewsSection from "@/pages/home/components/LatestNewsSection";
import FeaturedReviews from "@/pages/home/components/FeaturedReviews";
import IndustryPreview from "@/pages/home/components/IndustryPreview";
import { getFeatured } from "@/lib/content";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function Home() {
  useDocumentMeta({
    title: "汽车资讯网-最新汽车新闻与车型解析",
    description:
      "汽车网站为您提供最新汽车新闻、车型评测及行业动态，涵盖轿车、SUV、新能源车等多种类别，助您全面了解汽车资讯。",
    keywords: "汽车,汽车新闻,车型解析,新能源车,汽车评测,汽车资讯,汽车行业",
  });

  const featured = getFeatured();

  return (
    <div className="pb-4">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 pt-6">
        <HeroCarousel items={featured} />
      </div>

      <CategoryQuickEntry />
      <LatestNewsSection />
      <FeaturedReviews />
      <IndustryPreview />

      <section className="max-w-[1280px] mx-auto px-4 md:px-6 mt-14">
        <div className="bg-background-50 border border-background-200 rounded-lg p-6 md:p-10 grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-3">
              关于汽车资讯网
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              汽车资讯网是一个聚焦汽车行业的资讯平台，围绕最新汽车新闻、专业车型评测与行业动态，为汽车爱好者、潜在购车用户及行业观察者提供权威、丰富、分类明确的信息服务。我们覆盖轿车、SUV、新能源车、性能跑车等多个细分领域，帮助你快速了解车市、深入认识车型、把握行业趋势。
            </p>
            <div className="flex flex-wrap gap-3 mt-5">
              <Link
                to="/about"
                className="h-10 px-5 rounded-md bg-primary-600 text-background-50 text-sm flex items-center gap-1.5 hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                了解我们
                <i className="ri-arrow-right-line" />
              </Link>
              <Link
                to="/contact"
                className="h-10 px-5 rounded-md border border-background-300 text-foreground-800 text-sm flex items-center gap-1.5 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                联系我们
              </Link>
            </div>
          </div>
          <div className="grid grid-cols-3 lg:grid-cols-1 gap-4 lg:border-l lg:border-background-200 lg:pl-8">
            {[
              { value: "4+", label: "细分频道" },
              { value: "48+", label: "演示资讯" },
              { value: "24h", label: "持续更新" },
            ].map((stat) => (
              <div key={stat.label}>
                <p className="font-heading font-bold text-2xl md:text-3xl text-accent-600">
                  {stat.value}
                </p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}